// extracted by mini-css-extract-plugin
export default {"SimpleContainer":"SimpleSection_SimpleContainer__9VrXX","Title":"SimpleSection_Title__fHxRA","Text":"SimpleSection_Text__wut2a"};